import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=3385b116&"
import script from "./Registry.vue?vue&type=script&lang=ts&"
export * from "./Registry.vue?vue&type=script&lang=ts&"
import style0 from "./Registry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports